import { TotemDeviceToStorage } from "../models/totem-device";

const TOTEM_DEVICE = "totem_device";

export const getTotemDevice = () => {
  return localStorage.getItem(TOTEM_DEVICE);
};

export const saveTotemDevice = (totemDevice: TotemDeviceToStorage) => {
  localStorage.setItem(TOTEM_DEVICE, JSON.stringify(totemDevice));
};

export const removeTotemDevice = () => {
  localStorage.removeItem(TOTEM_DEVICE);
};

export const getTotemDevices = (): TotemDeviceToStorage | null => {
  const totemDevicesJson = localStorage.getItem(TOTEM_DEVICE);
  let totemDevices: TotemDeviceToStorage | null = null;

  if (totemDevicesJson) {
    try {
      totemDevices = JSON.parse(totemDevicesJson);
    } catch (error) {
      console.error("Erro ao fazer parse do JSON armazenado:", error);
      // Opcional: limpar o valor inválido para evitar erros futuros
      localStorage.removeItem(TOTEM_DEVICE);
    }
  }
  return totemDevices;
};

const hasTotemDevices = () => !!getTotemDevices();

export const totemDeviceService = {
  hasTotemDevices,
};
